import apiRequest from "../../utils/apiRequest";
import { shouldShowPackageFeatures } from "../../config/packageVisibility";

const confirmPaymentApi = async (plan, userId = null) => {
    // Check if user should have access to package features
    if (userId && !shouldShowPackageFeatures(userId)) {
        throw new Error('Package features are not available for this user');
    }

    return await apiRequest("session", "post", plan);
};

export default confirmPaymentApi;
